import { IRoomRectangle, ToolType } from "../../types/Floorplan.types";

export interface IRoomRects {
    roomRectangles?: IRoomRectangle[];
    selectedRoomIdx?: number;
    selectedTool?: ToolType;
}

const RoomRects = (props: IRoomRects) => {
    const { roomRectangles, selectedRoomIdx, selectedTool } = props;
    if (roomRectangles && roomRectangles.length > 0) {
        return (
            <g id="internalRooms">
                { roomRectangles && roomRectangles.length > 0 && roomRectangles.map((room,idx) => {
                    let className = "room room-" + idx;
                    let transform: string | undefined = undefined;
                    if (selectedTool === "Pointer" && selectedRoomIdx === idx) {
                        className = "draggable draggableRoom-" + idx;
                    }
                    if (room.rotation !== 0) {
                        const originX = room.width! / 2;
                        const originY = room.height! / 2;
                        transform = `rotate(${room.rotation}, ${originX}, ${originY})`;
                    }
                    return (
                        <svg className={className} key={`room_${idx}`} data-idx={idx} x={room.x} y={room.y} overflow="visible">
                            <g transform={transform}>
                                <rect x="0" y="0" width={room.width} height={room.height} stroke="black" fill="white" />
                            </g>
                        </svg>
                    );
                })}
            </g>
        );
    }
    return null;
};

export default RoomRects;